import { useTrackCallEvent } from './useTrackCallEvent';
import { useAppDispatch, useAppSelector } from '../useReduxToolkit';
import { TrackedEvents, getTrackingState } from '../../features/tracking';
import { callDurationTimer } from './callDurationTimer';
import type { SessionStartedProps } from './eventProps.types';
import { setTrackedCallStart } from '../../features/tracking/tracking.slice';
import { useVirtualBackgroundName } from '../useVirtualBackground';
import { otExceptionsStats } from './otExceptionsStats';
import { pubSubStatusStats } from './pubSubStatusStats';

type TrackCallStartEvent = (props: {
  sessionId?: string;
  dbSessionId?: string;
  identityId?: string;
  isAudioCall?: boolean;
}) => void;

export const useTrackCallStartEvent = (): TrackCallStartEvent => {
  const dispatch = useAppDispatch();
  const trackCallEvent = useTrackCallEvent();

  const { connectionTestResult } = useAppSelector(getTrackingState);

  const backgroundEffect = useVirtualBackgroundName();

  return ({ sessionId, dbSessionId, identityId, isAudioCall }): void => {
    dispatch(setTrackedCallStart());

    callDurationTimer.start();
    otExceptionsStats.collect();
    pubSubStatusStats.collect();

    const data: SessionStartedProps = {
      sessionId,
      personUuid: identityId,
      preCallConnection: connectionTestResult,
      audioOnly: isAudioCall,
    };

    const segmentData: SessionStartedProps = {
      sessionId: dbSessionId,
      channel: sessionId,
      personUuid: identityId,
      preCallConnection: connectionTestResult,
      audioOnly: isAudioCall,
      backgroundEffect,
    };
    trackCallEvent(TrackedEvents.StartCall, data, segmentData);
  };
};
